import authCheckApp from './authCheckApp'

/**
 * 打开单聊
 * @since 1.0.0
 * @param {Object} obj - 信息
 * @param {string} obj.userId 用户id
 * @returns {string} 返回打开单聊的状态
 * @example
 * 
 * openPerson({
 *   userId: '1ec6bd257f5b422fb2c635ede4d4d8b6',
 * })
 */
function openPerson(obj) {
    return new Promise((resolve, reject) => {
        authCheckApp()
            .then(() => {
                // 发起请求
                window.WebViewJavascriptBridge.callHandler('openPerson', {
                    'tribeId': obj.tribeId
                }, (response) => {
                    if (typeof response === 'string') {
                        response = JSON.parse(response)
                    }
                    // 返回状态值为0成功
                    if (response.status === 0) {
                        resolve(response)
                    } else {
                        reject(response)
                    }
                })
            }).catch(err => {
                reject(err)
            })
    })
}

export default openPerson